// Some injected content scripts attribute their errors to the host page, so
// extension URL filters alone miss them. Match the reported timing-script
// signature narrowly; an app error involving init_ts must still be reported.
export function filterBrowserError(event) {
  const injectedTimingError = event.exception?.values?.some(exception =>
    /contentScriptData\.init_ts/.test(exception.value || "") &&
    exception.stacktrace?.frames?.some(frame => /(?:^|\.)printTiming$/.test(frame.function || ""))
  )
  return injectedTimingError ? null : event
}
